import React, {Fragment, memo} from 'react';
import MUITypography from '@/components/MUI-Components/MUI-Typography';
import MUIGrid from '@/components/MUI-Components/MUI-Grid';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import Box from '@mui/material/Box';
import {spacing} from '@/styles/tokens';
const DisplayImage = dynamic(import('@/components/Ui-components/display-image'), {ssr: false});

// Migrated from solutions.scss `.nft-solution` (base) + globals.scss laptopScreen override,
// plus the pre-existing 430px override. Folded in directly — Solutions has a single caller
// (nft-marketplace-development), so cardSx is no longer exposed as a prop.
const sxSolutionsCard = {
    height: '320px !important', // no token match
    '@media (max-width: 1024px)': {height: '340px !important'},
    '@media (max-width: 430px)': {height: 'auto'}
} as const;

// Migrated from globals.scss `.solution-grid` (solutions.scss).
const sxSolutionGrid = {marginTop: spacing[20]};

interface SolutionsCard {
    icon: string;
    heading: string;
    body?: string;
    redirect?: string;
}

interface SolutionsProps {
    data?: SolutionsCard[];
    heading?: React.ReactNode;
    subheading?: React.ReactNode;
    className?: string;
}

const Solutions = (props: SolutionsProps) => {
    const {data, heading, className, subheading} = props;
    return (
        <Box>
            <Box className="spectrum-header-wrapper solutions">
                <MUITypography className="spectrum-heading top-space color-white" component="h3">
                    {heading}
                </MUITypography>
                <Box className="divder-wrapper">
                    <hr className="divider-line" />
                </Box>
                <Box className="sub-heading-box">
                    <MUITypography className="spectrum-sub-heading color-white">{subheading}</MUITypography>
                </Box>
            </Box>
            <MUIGrid
                container
                spacing={3}
                className={subheading ? 'solution-grid' : ''}
                sx={subheading ? sxSolutionGrid : undefined}
                paddingBottom={2.5}
            >
                {data?.map((subData: any, index: number) => (
                    <Fragment key={index}>
                        <MUIGrid item xs={12} sm={6} md={4}>
                            {subData.redirect !== '' ? (
                                <Link href={subData && subData?.redirect} className="services_link menu-links">
                                    <Box className={className} sx={sxSolutionsCard}>
                                        <DisplayImage src={subData.icon} alt={subData.heading} className="mobile-card-icon" />
                                        <MUITypography variant="h6" component="h4" className="solution-card-heading color-white">
                                            {subData.heading}
                                        </MUITypography>
                                        <MUITypography variant="body2" className="card-content color-white">
                                            {subData.body}
                                        </MUITypography>
                                    </Box>
                                </Link>
                            ) : (
                                <Box className={className} sx={sxSolutionsCard}>
                                    <DisplayImage src={subData.icon} alt={subData.heading} className="mobile-card-icon" />
                                    <MUITypography variant="h6" component="h4" className="solution-card-heading color-white">
                                        {subData.heading}
                                    </MUITypography>
                                    <MUITypography variant="body2" className="card-content color-white">
                                        {subData.body}
                                    </MUITypography>
                                </Box>
                            )}
                        </MUIGrid>
                    </Fragment>
                ))}
            </MUIGrid>
        </Box>
    );
};
export default memo(Solutions);
